import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, exhaustMap, filter, first, map, mergeMap, switchMap} from 'rxjs/operators';
import {EMPTY, of, pipe} from 'rxjs';
import {errorHappened} from '../app.types';
import {AuditLogsService} from './audit-logs.service';
import {auditLogsLoaded, loadAuditLogs, loadSegmentAuditLogs, segmentAuditLogsLoaded} from './audit-logs.state';
import {loadSegmentDetails, multishareComplete, selectSegmentDetails} from '../segment/segments.state';
import {Store} from '@ngrx/store';

@Injectable()
export class AuditLogsEffects {

  loadAuditLogs = createEffect(() => this.actions$
    .pipe(
      ofType(loadAuditLogs),
      exhaustMap((value) =>
        this.client
          .getAuditLogs(value.auditLogType,value.filter)
          .pipe(
            exhaustMap(result => of(auditLogsLoaded({auditLogs: result}))),
            catchError(err => of(errorHappened({error: {message: err.message}})))
          )
      )
    ));

  loadSegmentAuditLogs$ = createEffect(() => this.actions$
    .pipe(
      ofType(loadSegmentAuditLogs),
      switchMap(() =>
        this.store
          .select(selectSegmentDetails)
          .pipe(
            filter(details => details?.segment != null),
            first(),
            switchMap(
            details => details ? this.client.getSegmentAuditLogs(details.segment.id) : EMPTY
          ))
          .pipe(
            exhaustMap(result => of(segmentAuditLogsLoaded({segmentAuditLogs: result}))),
            catchError(err => of(errorHappened({error: {message: err.message}})))))
    ));

  constructor(private actions$: Actions,
              private store: Store,
              private client: AuditLogsService){}
}
